import type { FC } from 'react';
import { Box } from '@material-ui/core';
import Chart from 'react-apexcharts';
import Title from 'src/components/admin/Title';

interface PropsSeguimientoCumpleMeta {
  cumplimiento: { amount: number };
}

const SeguimientoCumpleMeta: FC<PropsSeguimientoCumpleMeta> = ({
  cumplimiento,
}) => {
  const title = 'Cumplimiento de Meta';
  const chart = {
    options: {
      chart: {
        stacked: true,
        toolbar: {
          show: false,
        },
      },
      colors: ['#1873b9'],
      plotOptions: {
        radialBar: {
          track: {
            background: '#76c8f2',
            strokeWidth: '97%',
            margin: 5,
          },
          dataLabels: {
            name: {
              show: false,
            },
            value: {
              show: true,
              fontSize: '32px',
              color: '#087bf6',
            },
          },
        },
      },
      states: {
        active: {
          filter: {
            type: 'none',
          },
        },
        hover: {
          filter: {
            type: 'none',
          },
        },
      },
    },
    legend: {
      show: false,
    },
    series: [cumplimiento.amount],
  };

  return (
    <Box p={2} height="250px" maxHeight="250px">
      <Title title={title} />
      <Chart height="250px" type="radialBar" {...chart} />
    </Box>
  );
};

export default SeguimientoCumpleMeta;
